export interface FeatureFlag {
  name: string;
  description: string;
}

export type AppId = 'controller' | 'hangar' | 'global';

export enum ControllerVersion {
  ControllerV1 = 1,
  ControllerV2,
}

export interface ControllerPrefs {
  optInControllerVersion?: ControllerVersion;
  welcomeAcknowledged?: boolean;
}
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface HangarPrefs {} // no prefs yet
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface GlobalPrefs {} // no prefs yet

export interface ControllerPrefsResult {
  appId: 'controller';
  preferences: ControllerPrefs;
}
export interface HangarPrefsResult {
  appId: 'hangar';
  preferences: HangarPrefs;
}
export interface GlobalPrefsResult {
  appId: 'global';
  preferences: GlobalPrefs;
}

export type UserPrefsResult = ControllerPrefsResult | HangarPrefsResult | GlobalPrefsResult;

export interface GetUserPrefsOptions {
  appId: AppId;
}

export type UpdateUserPrefsOptions = UserPrefsResult;

export interface MFAEnrollment {
  id: string;
  type: string;
  createdAt: string;
  confirmed: boolean;
}

export interface MFAEnrollmentTicket {
  ticketId: string;
  ticketUrl: string;
}
